import { saveMatrixSetting, updateShoppingcart } from '../../Helpers';
import { show, hide } from '../../Utils';

export class Shoppingcart {
    constructor() {
        this.toggleButton             = document.querySelector('#expand-collapse-btn');
        this.notOrderedStylesButton   = document.querySelector('#not_order_styles_options');
        this.detailsButtons           = document.querySelectorAll('.details-button');
        this.queryInput               = document.querySelector('input[name=query]');
        this.variantAmountInputs      = document.querySelectorAll('.input_variant_qty');
        this.variantAmountButtons     = document.querySelectorAll('.price-block .btn-number');
        this.submitShoppingcartButton = document.querySelector('#submit-shoppingcart');
    }

    actions() {
        this.#updateActions();

        this.detailsButtons.forEach(element => {
            element.onclick = event => {
                if (!element.closest('.details-button').classList.contains('collapsed')) {
                    this.notOrderedStylesButton.style.display = 'block';
                }
                else {
                    let countOpen = 0;
                    document.querySelectorAll('.details-button').forEach(element => {
                        if (element.classList.contains('collapsed')) {
                            countOpen++;
                        }
                    });

                    if (countOpen === 0) {
                        this.notOrderedStylesButton.style.display = 'none';
                    }
                }
            }
        });

        if (this.toggleButton) {
            this.toggleButton.onclick = event => {
                event.preventDefault();

                const { expand } = this.toggleButton.dataset;

                this.#toggleOrderMatrix(expand);
            };
        }

        this.queryInput.onkeyup = event => {
            const query       = this.queryInput.value;
            const queryLength = query.length;

            if (queryLength > 0) {
                document.querySelectorAll('.shopping-cart-form > .shopping-cart-item').forEach(element => {
                    let { searchterms } = element.dataset;

                    element.style.display = searchterms.toLowerCase().indexOf(query) != -1 ? show(element) : hide(element);
                });
            }
        }

        if (this.submitShoppingcartButton) {
            this.submitShoppingcartButton.onclick = event => {
                event.preventDefault();

                if ($('#shoppingcartModal').length) {
                    $('#shoppingcartModal').modal('show');
                } else {
                    location.href=this.submitShoppingcartButton.dataset.url;
                }
            };
        }
    }

    #updateActions() {
        this.variantAmountButtons.forEach(element => {
            element.onclick = event => {
                event.preventDefault();

                const { field, type } = element.dataset;

                const matrixId = element.closest('.price-block').getAttribute('id');
                const input = document.querySelector(`#${matrixId} input[name=${field}]`);

                const { orderSteps } = input.dataset;

                let currentVal = parseInt(input.value);
                const hasOrderSteps = orderSteps !== undefined ? true : false;
                const newVal = (hasOrderSteps ? Math.max(1, orderSteps) : 1);

                // Check if currentVal is NaN
                if (currentVal !== currentVal) {
                    currentVal = 0;
                }

                if (type == 'minus') {
                    if (currentVal > 0) {
                        input.value = currentVal - newVal;

                        this.#triggerUpdateShoppingcart(input);
                    }
                } else if(type == 'plus') {
                    input.value = currentVal + newVal;

                    this.#triggerUpdateShoppingcart(input);
                }
            };
        });

        this.variantAmountInputs.forEach(element => {
            let value = element.value !== '' ? element.value : 0;
            element.dataset.currentQty = value;

            element.onchange = event => {
                this.#triggerUpdateShoppingcart(element);
            };
        });

        $('.input_discount').change(function () {
            $('.discount-inputhelp-message').hide();

            // only allow 0-9 in input
            var v = $(this).val().trim().replace(',', '.').replace(/[^0-9]\.]/gi, '');

            var hasbeenrounded = false;

            // check for maximum
            var max = $(this).attr('data-maxdiscount');
            if (parseFloat(max) < parseFloat(v)) {
                v = max;
                hasbeenrounded = true;
            }

            // check for minmum
            var min = $(this).attr('data-mindiscount');
            if (parseFloat(min) > parseFloat(v)) {
                v = min;
                hasbeenrounded = true;
            }

            $(this).attr('data-hasbeenrounded', hasbeenrounded);

            // if discounttype is absolute, the discount must be a multiple of quantity
            var discounttype = $(this).attr('data-discounttype');
            if (discounttype == 'absolute') {
                var quantity = $(this).attr('data-quantity');
                var division = Math.floor(v * 100 / quantity);
                v = (division * quantity) / 100;
                v = parseFloat(v).toFixed(2);
            }

            if (discounttype == 'percentage') {
                v = parseFloat(v).toFixed(2);
            }

            // only update input when the value is different, an update causes the cursor to move
            if (v != $(this).val()) {
                $(this).val(v);
            }

            updateShoppingcart($(this)[0], v);

            setTimeout(() => {
                $('.discount-inputhelp-message').show();
            }, '1000');
        });

        if (!document.querySelector('#checkout-form') && authType !== 'salesagent') {
            updateShoppingcart();
        }
    }

    #toggleOrderMatrix(expand) {
        saveMatrixSetting(expand === 'open' ? 'close' : 'open');

        const { translationAll, translationExpand, translationCollapse } = this.toggleButton.dataset;

        this.toggleButton.dataset.expand = expand === 'open' ? 'close' : 'open';
        this.toggleButton.innerHTML = `<i class="fa fa-chevron-down" aria-hidden="true"></i><span>${translationAll} ${expand === 'open' ? translationExpand : translationCollapse}</span>`;
        this.notOrderedStylesButton.style.display = expand === 'open' ? 'none' : 'block';

        $('.ordermatrix').collapse(expand === 'open' ? 'hide' : 'show');
    }

    #triggerUpdateShoppingcart(element) {
        const value = element.value.trim().replace(/[^0-9]/gi, '');

        if (value != element.value) {
            element.value = value;
        }

        if (element.value.length > 4) {
            element.classList['font-size'] = 'x-small';
        } else {
            element.classList['font-size'] = 'inherit';
        }

        updateShoppingcart(element, element.value);
    }
}
